//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.ParentViewBuilder.js";
import "../Drawings/Drawings.SectionLineSettingsBuilder.js";
import "../no/Section.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AssociateToSketch",1,0],[0,"FoldedToggle",1,0],[1,"ParentView",0,"Drawings.ParentViewBuilder",0],[0,"ReverseDirection",1,0],[0,"SectionLineType",1,0],[0,"SectionType",1,0],[1,"Settings",0,"Drawings.SectionLineSettingsBuilder",0],[1,"SketchSection",0,"Section",0],[1,"SourceView",0,"Drawings.SelectDraftingView",0]],[[["sketch"],"SetSketch",{},1,0],[["selectedview"],"IsValidSourceViewForDerivedSectionLine",{R_:{validSourceView:''}},1,0],[["selectedview"],"IsValidParentViewForDerivedSectionLine",{R_:{validParentView:''}},1,0]],[]];
SPLM.Drawings.SketchSectionLineBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SketchSectionLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.SketchSectionLineBuilder.Type = Object.freeze({
    "StandAlone" : "StandAlone", "Derived" : "Derived"});

SPLM.Drawings.SketchSectionLineBuilder.SectionLineTypes = Object.freeze({
    "SimpleStepped" : "SimpleStepped", "Half" : "Half", "PoinToPoint" : "PoinToPoint"});

export default SPLM;